<glitch-hero mainTitle="MY RESUME" subtitle="Find out more about my experiences as a Software Engineer."></glitch-hero>
<experience-section></experience-section>
<education-section></education-section>
<skills-section></skills-section>
<testimonials-section></testimonials-section>